module.exports = __webpack_public_path__ + "img/TIMES-CIRCLE.2e5b3ad6.svg";